<template>
  <div class="finance-page ">
    <div class="top-bg"></div>
    
    <div class="top-box bg2">
      <div class="title">{{$t('finance.desc1')}}</div>
      <div class="sub-title clear">{{$t('finance.desc2')}}</div>

      <div class="flex-column-start-center total">
        <span class="label">{{i18n.t('finance.label2')}}</span>
        <div class="count">${{statisticsData.Amount ? parseFloat(statisticsData.Amount).toFixed(4) : '0.0000'}}</div>
      </div>

      <div class=" statistics-box flex-start">
        <div class="info">
          <div class="label">{{i18n.t('finance.label5')}}</div>
          <div class="value">${{userMoney ? parseFloat(userMoney).toFixed(4) : '0.0000'}}</div>
        </div>
        <div class="info">
          <div class="label">{{i18n.t('finance.label4')}}</div>
          <div class="value">${{statisticsData.Income ? parseFloat(statisticsData.Income).toFixed(4) : '0.0000'}}</div>
        </div>
        <div class="info">
          <div class="label">{{i18n.t('finance.label6')}}</div>
          <div class="value">${{statisticsData.YesterdayIncome ? parseFloat(statisticsData.YesterdayIncome).toFixed(4) : '0.0000'}}</div>
        </div>
      </div>
    </div>


    <div class="tabs flex clear">
      <div class="tab" :class="tabIndex == 0 ? 'active' : ''" @click="changeTab(0)">{{$t('finance.tab3')}}</div>
      <div class="tab" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{$t('finance.tab4')}}</div>
      <div class="tab" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{$t('finance.tab5')}}</div>
    </div>

    <div class="list-table">
      <div class="th-line flex-center-between">
        <div class="th flex-2">{{ $t('li-cai-bi-zhong') }}</div>
        <div class="th flex-2">{{ $t('li-cai-jine-shi-jian') }}</div>
        <div class="th flex-2">{{ $t('nian-hua-shou-yi') }}</div>
        <div class="th flex-2">{{ $t('financeBuy.label2') }}</div>
        <!-- <div class="th flex-2">昨日收益</div> -->
        <div class="th flex-2">{{ $t('finance.label4') }}</div>
        <div class="th action flex-2">{{ $t('finance.label12') }}</div>
        <div class="th action" v-if="tabIndex == 0">{{ $t('cao-zuo-1') }}</div>
      </div>
      <div class="tbody" v-if="financeDataList.length > 0">
        <div class="td-line flex-center-between" v-for="(item, i) in financeDataList" :key="i" >
          <div class="td flex-2 flex-center-start">
            <img :src="item.FinancialSetup.Currency.Logo ? `/upload/${item.FinancialSetup.Currency.Logo}` : bitUrl" alt="">
            <span>{{item.FinancialSetup.Currency.Name}}</span>
          </div>
          <div class="td flex-2">
            <div>{{parseFloat(item.OrderAmount).toFixed(2)}}</div>
            <div>{{item.CreatedAt}}</div>
          </div>
          <div class="td flex-2">{{item.FinancialSetup.IncomeRatio}}%</div>
          <div class="td flex-2">{{item.FinancialSetup.ProductType === 1 ? $t('finance.label13') : $t('finance.label14')}}</div>
          <div class="td flex-2">{{parseFloat(item.IncomeAmount).toFixed(2)}}</div>
          <div class="td action flex-2">{{$t(`finance.tab${tabIndex + 2}`)}}</div>
          <div class="td action" v-if="tabIndex == 0">
            <div class="btn" @click="toWithdraw(item)">{{ $t('shu-hui') }}</div>
          </div>
        </div>
      </div>
      <div v-if="financeDataList.length == 0 && isInit" class="empty-table">
        <img :src="emptyUrl" alt="">
        <div>{{$t('common.empty')}}</div>
      </div>
    </div>

  </div>
</template>
<script>
import { Button, List } from 'vant'
import { financeWithdraw, financeList, financialStatistics } from '@/api/finance'
import { wallet } from '@/api/assest'
export default {
  components: {
    Button,
    List
  },
  data() {
    return {
      emptyUrl: require('../../assets/imgs/empty.png'),
      bitUrl: require('../../assets/imgs/bit1.png'),
      page: {
        page: 1,
        limit: 10
      },
      userMoney: 0,
      isInit: false,
      loading: false,
      finished: false,
      totalPage: 1,
      tabIndex: 0,
      finishedText: '',
      financeDataList: [], //申购产品列表
      ownerFinanceList: [], //已申购列表
      statisticsData: {}
    }
  },
  mounted() {
    this.init()
    this.initFinance()
    this.initStatistics()
  },
  methods: {
    init() {
      let form = new FormData()
      form.append('ShortName', 'usdt')
      form.append('current', 1)
      form.append('pageSize', 10)
      wallet(form).then(res => {
        let data = res.data.Items[0]
        if (data) {
          this.userMoney = parseFloat(data.FinanceUse)
        }
      })
    },
    initStatistics() {
      financialStatistics().then(res => {
        this.statisticsData = res.data || {}
        
      })
    },
    initFinance() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 100)
      financeList(form).then(res => {
        this.ownerFinanceList = res.data.Items
        this.isInit = true
        this.financeDataList = this.ownerFinanceList.filter(v => {
          return v.Status == this.tabIndex
        })
      })
    },
    onLoad() {
      this.page.page += 1
      this.init(true)
    },
    toDetail(data) {
      sessionStorage.setItem('financeData', JSON.stringify(data))
      this.$router.push({
        path: '/financeDetail',
        query: {
          type: this.tabIndex
        }
      })
    },
    changeTab(i) {
      this.tabIndex = i
      this.page.page = 1
      this.financeDataList = []
      this.initFinance()
    },
    back() {
      this.$router.go(-1)
    },
    toWithdraw(data) {
      let form = new FormData()
      form.append('ID', data.ID)
      financeWithdraw(form).then(res => {
        if (res.code == 0) {
          this.$toast.success(this.$t('finance.success'))
          this.initFinance()
          this.initStatistics()
        } else {
          this.$toast.fail(res.msg)
        }
      })
    }
  }
}
</script>